import { GetRulesMatchingTransfersDto } from "@common/dto/transactionRule/get-rules-matching-transfers.dto";
import { GetRuleMatchingTransfersResponseDto } from "@common/dto/transactionRule/get-rule-matching-transfers-response.dto";
import { ruleContract } from "@common/contracts/rule.contract";
import { TransactionDto } from "@common/dto/transactions/transaction.dto";
import { Transaction } from "@common/types/transaction";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { getBackendAPIClient } from "./backendAPIClient";

const ruleContractClient = getBackendAPIClient(ruleContract);

export async function getMatchingTransfersForRule(
    workspaceId: string,
    data: GetRulesMatchingTransfersDto,
) {
    const response = await ruleContractClient.getMatchingTransferTransactions({
        params: { workspaceId },
        body: data,
    });

    return GetRuleMatchingTransfersResponseDto.deserialize(response.body);
}

type AppliedTransferTransactionsPage =
    | {
          mode: "allow";
          matches: Array<{
              transaction: Transaction;
              match: Transaction;
          }>;
          total: number;
      }
    | {
          mode: "disallow";
          transactions: TransactionListItem[];
          total: number;
      };

export async function getAppliedTransfersForRule(
    workspaceId: string,
    ruleId: string,
    params: { page: number; limit: number },
): Promise<AppliedTransferTransactionsPage> {
    const response = await ruleContractClient.getAppliedTransferTransactions({
        params: { workspaceId, ruleId },
        body: params,
    });

    if (response.status !== 200) {
        throw new Error("Failed to fetch applied transfer transactions");
    }

    const body = response.body;

    if (body.mode === "allow") {
        return {
            mode: "allow",
            matches: body.matches.map(
                (pair: {
                    transaction: TransactionDto;
                    match: TransactionDto;
                }) => ({
                    transaction: TransactionDto.deserialize(pair.transaction),
                    match: TransactionDto.deserialize(pair.match),
                }),
            ),
            total: body.total,
        };
    }

    return {
        mode: "disallow",
        transactions: body.transactions,
        total: body.total,
    };
}
